import clsx from "clsx";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { 
  LocaleSvg,
  HelpCenterSvg,
  FeedbackSvg,
} from "@/assets/icons";
import {
  LocaleMenu,
} from "@/components";
import { useRef, useState } from "react";

type MoreMenuProps = {
  className?: string;
}

const MoreMenu = (props: MoreMenuProps) => {
  const {
    className,
  } = props;

  const { t } = useTranslation();
  const [localeMenuVisible, setLocaleMenuVisible] = useState<boolean>(false);
  const timeoutIdRef = useRef<any>();

  const menuList = [
    {
      key: "help_center",
      icon: <HelpCenterSvg></HelpCenterSvg>,
      title: t("menu_title_help_center"),
      link: "https://support.fotor.com/hc/en-us",
    },
    {
      key: "feedback",
      icon: <FeedbackSvg></FeedbackSvg>,
      title: t("menu_title_feedback"),
      link: "https://support.fotor.com/hc/en-us/requests/new",
    },
    {
      key: "locale",
      icon: <LocaleSvg></LocaleSvg>,
      title: t("menu_title_locale"),
      menu: <LocaleMenu></LocaleMenu>,
      menuVisible: localeMenuVisible,
      handleMouseEnter: () => {
        clearTimeout(timeoutIdRef.current);
        setLocaleMenuVisible(true);
      },
      handleMouseLeave: () => {
        timeoutIdRef.current = setTimeout(() => {
          setLocaleMenuVisible(false);
        }, 500);
      }
    }
  ];

  return (
    <div
      className={clsx(
        styles["more_menu"],
        className,
      )}
    >
      <ul
        className={styles["menu_list"]}
      >
        {menuList.map(item => (
          <li
            key={item.key}
            className={styles["menu_item"]}
          >
            {
              item.link ? (
                <a 
                  className={styles["menu_item_inner"]}
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.icon}
                  <span className={styles["menu_item_title"]}>{item.title}</span>
                </a>
              ) : (
                <div
                  className={styles["menu_item_inner"]}
                  onMouseEnter={item.handleMouseEnter}
                  onMouseLeave={item.handleMouseLeave}
                >
                  {item.icon}
                  <span className={styles["menu_item_title"]}>{item.title}</span>
                  {item.menu && item.menuVisible && (
                    <div
                      className={styles["menu_item_second_menu"]}
                    >
                      {item.menu}
                    </div>
                  )}
                </div>
              )
            }
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MoreMenu;